import { render, staticRenderFns } from "./UserEmailPill.vue?vue&type=template&id=0c1b786d&scoped=true&"
import script from "./UserEmailPill.vue?vue&type=script&lang=ts&"
export * from "./UserEmailPill.vue?vue&type=script&lang=ts&"
import style0 from "./UserEmailPill.vue?vue&type=style&index=0&id=0c1b786d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1b786d",
  null
  
)

export default component.exports